import React, { Fragment, useEffect, useState } from 'react';

import { GroupCheckFilterPropsType } from './types';
import { isIn } from '../../../../helpers';

const GroupCheckFilter = ({
                            optionsSelected,
                            allSelected,
                            groupLabel,
                            options,
                            addPosition,
                            tab
                          }: GroupCheckFilterPropsType) => {
  
  const checks = options.map((option, index) => {
    const position = { name: option.key, value: option.key };
    return <Fragment key={index + option.label}>
      <input
        className="styled-checkbox" id={tab + groupLabel + option.key}
        checked={isIn(optionsSelected, position)}
        type="checkbox"
        value={option.key}
        onChange={() => {
          if((optionsSelected.length === checks.length -1)&& ! isIn(optionsSelected, position)){
            addPosition([position], groupLabel);
          }else if(optionsSelected.length === checks.length){
            addPosition([position], groupLabel);
          }else{
            addPosition([position]);
          }
        }}
      />
      <label
        htmlFor={tab + groupLabel + option.key}
        id={tab + groupLabel + option.key + '-label'}
        style={{ fontWeight: isIn(optionsSelected, position) ? 'bold' : undefined }}
        className="check-l"
      >
        {option.label + ''}
      </label>
    </Fragment>;
  });
  const all = options.map(option => ({ name: option.key, value: option.key }));

  return (
    <>
      <div className="p-h-02">
        <b>{groupLabel}</b>
        <div className="p-i-02">
          <label className="p-all">Select All</label>
          <input
            type="checkbox" id={tab + groupLabel} name="set-name" className="switch-input"
            checked={allSelected}
            onChange={() => {
              if (allSelected) {
                addPosition(all, groupLabel);
              } else {
                addPosition(all.filter((position) => (!isIn(optionsSelected, position))), groupLabel);
              }
            }}
          />
          <label htmlFor={tab + groupLabel} id={tab + groupLabel + '-label'} className="switch-label" />
        </div>
      </div>
      <div className="p-b-02">
        {checks}
      </div>
    </>
  );
};

export default GroupCheckFilter;
